export default "__VITE_ASSET__ea646552__"